import React from 'react';
import GoodEnglish from './good-english/GoodEnglish';
import { dataGoodEnglish1aL03 } from './good-english/good_english_data_1a_l03';

function GoodEnglish1aL03() {
  return <GoodEnglish data={dataGoodEnglish1aL03} />;
}

export default GoodEnglish1aL03;
